// extracted by mini-css-extract-plugin
export default {"icon":"PaymentCardBrandIcon_icon__OKsI6"};